import * as toastr from 'toastr';
import { OBTER_UNIDADES } from '../actions/index';

export default function (state = {}, action) {
    switch (action.type) {
        case OBTER_UNIDADES:                
            if(action.error){
                toastr.error("Erro obtendo unidades.");
                return state;                
            }else{           
                return action.payload;
            }
        default:
            return state;
    }   
}
